import SideMenu from "../Components/Layout/SideMenu";
import TopBar from "../Components/Layout/TopBar";
import { Grid } from "@mui/material";

const AuthenticatedRoute = ({ children }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <TopBar />
      </Grid>
      <Grid item xs={4}>
        <SideMenu />
      </Grid>
      <Grid
        item
        sx={{
          // marginLeft: "240px",
          // marginTop: "48px",
          // padding: "24px",
          backgroundColor: "#F8FAFB",
          width: "100%",
          height: "100%",
        }}
        xs={8}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default AuthenticatedRoute;
